<template>
  <section id="login">
    <div class="container">
      <div class="logo-cont">
        <img alt="login-bg" src="../assets/images/x-bg.png" class="login-bg" />
        <div class="logo">
          <GridxLogo />
        </div>
      </div>

      <form id="app" @submit="onLogin" action="https://vuejs.org/" method="post">
        <div class="login-fields col-12 col-md-6 offset-md-3">
          <NormalInput name="email" label="Email" v-model="email" />
          <NormalInput name="password" label="Contraseña" type="password" v-model="password" />
          <div class="row">
            <div class="col-12">
              <LinkButton
                @click="forgotPassword"
                underline
                class="forgot-password"
              >Olvidé mi contraseña</LinkButton>
            </div>
          </div>
          <p class="error">{{error}}</p>
        </div>

        <div class="col-12 col-md-6 offset-md-3 login-button-container">
          <PrimaryButton @click="onLogin" class="login-button">{{loginButtonText}}</PrimaryButton>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import GridxLogo from '../assets/icons/gridx-logo.svg';
import NormalInput from '../components/Input/NormalInput.vue';
import PrimaryButton from '../components/Button/PrimaryButton.vue';
import LinkButton from '../components/Button/LinkButton.vue';

export default {
  name: 'Login',
  components: {
    GridxLogo,
    NormalInput,
    PrimaryButton,
    LinkButton,
  },
  data() {
    return {
      email: '',
      password: '',
      error: '',
      loginButtonText: 'INGRESAR',
    };
  },
  methods: {
    forgotPassword() {
      this.$router.push({ name: 'Reset' });
    },
    async onLogin() {
      this.error = '';
      if (!this.email || !this.password || !this.validateEmail(this.email)) {
        this.error = 'Email o contraseña incorrectos';
        return;
      }

      this.$store.commit('toggleLoadingBar', true);

      this.loginButtonText = 'CARGANDO...';

      try {
        const formData = new FormData();
        formData.append('email', this.email);
        formData.append('password', this.password);

        const response = await fetch('https://gridxbackend.dreamhosters.com/api/login', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          this.$store.commit('toggleLoadingBar', false);
          this.loginButtonText = 'INGRESAR';
          this.error = 'Email o contraseña incorrectos';
          return;
        }

        const data = await response.json();

        this.$store.commit('toggleLoadingBar', false);

        localStorage.setItem('gridx_app_token', data.data.access_token);

        this.$router.push({ name: 'Home' });
      } catch (e) {
        this.$store.commit('toggleLoadingBar', false);
        this.loginButtonText = 'INGRESAR';
        this.error = 'Ocurrió un error con la petición';
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  min-height: 100vh;
  background: #330e2f;
  overflow-x: hidden;
  padding-top: 50px;
  padding-bottom: 50px;
}

.logo-cont {
  height: 185px;
}

.logo {
  display: block;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
  height: 29px;
  svg {
    margin: 0 auto;
    display: block;
    height: 29px;
  }
}

.login-bg {
  position: absolute;
  right: 15px;
  max-width: 752px;
}

.login-fields {
  margin-top: 30px;
}

.login-button-container {
  margin-top: 20vh;
}

.login-button {
  width: 100%;
}

.error {
  font-size: 16px;
  color: #ff5f3c;
  position: absolute;
}

.forgot-password {
  float: right;
  margin-top: 10px;
}
</style>
